<!-- eslint-disable vue/valid-v-slot -->
<template>
    <div class="archive-page">
      <div class="page-header">
        <div class="page-header-text">
          <h1 class="page-title">Archiwum kierowców</h1>
        </div>
      </div>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="drivers"
            class="elevation-1"
            :loading="loading"
            :search="search"
            :options.sync="options"
            :server-items-length="totalItems"
          >
            <template v-slot:top>
              <div class="table-section-title">
                <div class="filter-icon"><v-icon size="18" color="#5478FF">mdi-archive</v-icon></div>
                <div class="filter-title">{{ $t('archiveDrivers.title') }}</div>
              </div>
              <div>
                <v-text-field
                  v-model="search"
                  :label="$t('archiveDrivers.searchLabel')"
                  outlined
                  dense
                  hide-details
                  prepend-inner-icon="mdi-magnify"
                  class="mx-4"
                ></v-text-field>

                <v-select
                  class="mx-4"
                  v-model="selectSubCompanyId"
                  :items="subCompanies"
                  multiple
                  item-text="name"
                  item-value="id"
                  :label="$t('archiveDrivers.department')"
                  :rules="[validateOptionalUUID]"
                  return-object
                  outlined
                  dense
                  hide-details
                />
              </div>
            </template>
                      <template v-slot:item.details="{ item }">
            <v-btn class="warning" @click="infoDriver(item.id)"
              ><v-icon small class="pt-1">mdi-pencil</v-icon></v-btn
            >
          </template>
            <template v-slot:item.revertDriver="{ item }">
              <v-btn class="warning" @click="revertDriver(item.id)"
                ><v-icon small class="pt-1">mdi-restore</v-icon></v-btn
              >
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
  const axios = require("axios");
  import Swal from "sweetalert2";
  export default {
    data() {
      return {
        search: "",
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        totalItems: 0,
        drivers: [],
        headers: [
        {
            text: "Gotowy do rozliczeń?",
            align: "start",
            sortable: false,
            value: "isReadyForSettlements",
          },
          {
            text: "Wewnętrzny Id",
            align: "start",
            sortable: false,
            value: "numericId",
          },
          {
            text: "Imię",
            align: "start",
            sortable: false,
            value: "firstName",
          },
          {
            text: "Nazwisko",
            align: "start",
            sortable: false,
            value: "lastName",
          },
          {
            text: "Student?",
            align: "start",
            sortable: false,
            value: "isStudent",
          },
          {
            text: "Mail",
            align: "start",
            sortable: false,
            value: "email",
          },
          {
            text: "Telefon",
            align: "start",
            sortable: false,
            value: "phone",
          },
          {
            text: "Częstotliwość Wypłat",
            align: "start",
            sortable: false,
            value: "payoutSchedule",
          },
          {
            text: "Komornik?",
            align: "start",
            sortable: false,
            value: "repossesion",
          },
          {
            text: "Auto",
            align: "start",
            sortable: false,
            value: "car",
          },
          {
            text: "Powiązane Firmy/Oddziały",
            align: "start",
            sortable: false,
            value: "subcompanyNames",
          },
          { text: "", value: "details", sortable: false },
          { text: "", value: "revertDriver", sortable: false },
        ],
        loading: false,
        selectSubCompanyId: null,
        companies: [],
        departments: [],
        subCompanies: [],
        rules: {
          required: (value) => !!value || "Wymagane.",
          email: (value) => /.+@.+\..+/.test(value) || "Nieprawidłowy email.",
          password: (value) =>
            value.length >= 6 || "Hasło musi mieć co najmniej 6 znaków.",
        },
      };
    },
    watch: {
      "formData.subCompanyIds": function (newVal) {
        if (newVal) {
          this.getDepartmentsSelect();
        } else {
          this.departments = [];
        }
      },
      options: {
        handler() {
          this.initialize();
        },
        deep: true,
      },
      search: {
        handler() {
          this.initialize();
        },
        deep: true,
      },
      selectSubCompanyId: {
        handler() {
          this.initialize();
        },
      },
    },
    async created() {
      await this.initialize();
    },
    methods: {
      validateUUID(value) {
        const uuidRegex =
          /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return !value || uuidRegex.test(value) || "Nieprawidłowy format UUID";
      },
      validateOptionalUUID(value) {
        return value === null || this.validateUUID(value.id || value);
      },
      async toggleLoading(type) {
        const toggle = type;
        localStorage.setItem("loading", toggle);
        window.dispatchEvent(
          new CustomEvent("toggleLoading", {
            detail: {
              loading: localStorage.getItem("loading"),
              overlay: localStorage.getItem("loading"),
            },
          })
        );
      },
      async getSubcompanySelect() {
        await this.toggleLoading(true);
        try {
          const subCompanies = await axios({
            method: "get",
            url: process.env.VUE_APP_ROOT_API + `sub-company`,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });
          this.subCompanies = subCompanies.data.data.map((it) => {
            return {
              id: it.id,
              name: it.name,
            };
          });
        } catch (e) {
          console.log(e);
          Swal.fire("Błąd", e.response.data.message.toString(), "error");
        }
        await this.toggleLoading(false);
      },
        async infoDriver(id) {
      location.href = `/driver-details?id=${id}`;
    },
      async revertDriver(id) {
        Swal.fire({
          title: "Napewno przywrócić?",
          text: "",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Tak",
          cancelButtonText: "Anuluj",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await axios({
                method: "post",
                url: process.env.VUE_APP_ROOT_API + "drivers/revert",
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token"),
                },
                data:{
                    id
                }
              });
              await this.initialize();
            } catch (e) {
              console.log(e);
              Swal.fire("Błąd", e.response.data.message.toString(), "error");
            }
          }
        });
      },
      async initialize() {
        await this.getSubcompanySelect();
        this.loading = true;
        if (this.search.trim().length > 0) {
          this.options.page = 1;
        }
        try {
          const drivers = await axios({
            method: "get",
            url:
              process.env.VUE_APP_ROOT_API +
              `drivers/archive`,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
            params:{
                take: this.options.itemsPerPage,
                skip: this.options.page,
                search: this.search,
                subCompanyIds: this.selectSubCompanyId?.length > 0 
                  ? this.selectSubCompanyId.map((it) => it.id) 
                  : []
              }}
          );
          this.drivers = drivers.data.data.result.map((p) => {
            return {
              id: p.id,
              numericId: p.numericId,
              email: p.email,
              firstName: p.firstName,
              lastName: p.lastName,
              phone: p.phone,
              isReadyForSettlements: p.isReadyForSettlements ? '🟢' : '🔴',
              isStudent: p.zusType === "STUDENT" ? "Tak" : "Nie",
              repossesion: p.isReposession ? "Tak" : "Nie",
              car: p.car?.plate || p.secondCar?.plate || "",
              payoutSchedule: p.payoutSchedule,
              companyName: p.company.name,
              subcompanyNames: p.subCompanies
                .map((it) => it.subcompany.name)
                .toString(),
            };
          });
          this.totalItems = drivers.data.data.count;
        } catch (e) {
          console.log(e);
          Swal.fire("Błąd", e.response.data.message.toString(), "error");
        }
        this.loading = false;
      },
    },
  };
  </script>
  
<style scoped>
.archive-page { background: #181C28; min-height: calc(100vh - 56px); padding: 16px 16px 40px; margin: -24px; color: #fff; }
.page-header { padding: 4px 4px 18px; }
.page-eyebrow { font-size: 12px; color: #6E7691; font-weight: 500; text-transform: capitalize; }
.page-title { font-size: 22px; font-weight: 800; color: #fff; margin: 2px 0 0; letter-spacing: -0.02em; }
.table-section-title { display: flex; align-items: center; gap: 10px; padding: 14px 16px 12px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.filter-icon { width: 32px; height: 32px; border-radius: 10px; background: rgba(41,98,255,0.18); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.filter-title { font-size: 15px; font-weight: 700; color: #fff; letter-spacing: -0.01em; flex-grow: 1; }

.archive-page >>> .v-card { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; box-shadow: none !important; color: #fff !important; }
.archive-page >>> .v-text-field input { color: #fff !important; }
.archive-page >>> .v-text-field:not(.v-text-field--outlined) > .v-input__control > .v-input__slot::before { border-color: rgba(255,255,255,0.16) !important; }
.archive-page >>> .v-label { color: #6E7691 !important; }
.archive-page >>> .v-data-table { background: #232838 !important; border: 1px solid rgba(255,255,255,0.06) !important; border-radius: 18px !important; color: #fff !important; box-shadow: none !important; }
.archive-page >>> .v-data-table thead tr th { background: #1F2434 !important; color: #6E7691 !important; font-size: 11px !important; font-weight: 700 !important; text-transform: uppercase; letter-spacing: 0.04em; border-bottom: 1px solid rgba(255,255,255,0.06) !important; }
.archive-page >>> .v-data-table tbody tr { background: #232838 !important; }
.archive-page >>> .v-data-table tbody tr:hover { background: #2A3042 !important; }
.archive-page >>> .v-data-table tbody tr td { color: #fff !important; border-bottom: 1px solid rgba(255,255,255,0.04) !important; }
.archive-page >>> .v-data-footer { background: #1F2434 !important; color: #B0BEC5 !important; border-top: 1px solid rgba(255,255,255,0.06) !important; }
.archive-page >>> .v-btn:not(.v-btn--icon) { border-radius: 10px !important; text-transform: none !important; font-weight: 600 !important; }
.archive-page >>> .v-chip { border-radius: 999px !important; font-weight: 700 !important; }
.archive-page >>> .v-divider { border-color: rgba(255,255,255,0.06) !important; }
.archive-page >>> .v-progress-linear { background: rgba(255,255,255,0.06) !important; }
.archive-page >>> .v-dialog .v-card { background: #232838 !important; }
</style>
  